import { useState, useEffect } from "react"
import {useAnswerUserQuestionMutation } from "./userQuestionApiSlice"
import { useNavigate, useParams } from "react-router-dom"


import 'react-quill/dist/quill.snow.css'; // import the styles
import Question from "./partial/Question"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";

const AnswerForm = ({ currQuestion, userQuestionId, answered, setUserSelectedQuestion }) => {
    const {groupId, type} = useParams()
    const [answerQuestion, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAnswerUserQuestionMutation()

    const navigate = useNavigate()

    const [answer, setAnswer] = useState( answered );

    useEffect(() => {

        if (isSuccess ) {
           
            //navigate(`/${type}/${groupId}/question-sets`);
        }

    }, [isSuccess, navigate])
    useEffect(()=>{
        setAnswer(answered)
    }, [answered])
    const canSave =[answer].every(Boolean) && !isLoading;

    const onSaveQuestionSetClicked = async (e) => {
        if (canSave) {
            setUserSelectedQuestion("")
            const currAnswer = answer
            setAnswer("");
            await answerQuestion({
                userQuestionId,
                questionId:currQuestion._id,
                answerId: currAnswer,
              })
             
            
        }
    }
    const changeAnswer = (id)=>{
        setAnswer(id)
    }


    const errClass = (isError ) ? "errmsg" : "offscreen"
 
    const errContent = (error?.data?.message) ?? ''



    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>

              <Question   question={currQuestion} changeAnswer={changeAnswer} answered={answer}  />
             { canSave &&  <button className="large-btn" onClick={onSaveQuestionSetClicked} >
                    שמור
                    <FontAwesomeIcon icon={faSave} />
               </button>}
            </form>
           
          
        </>
    )

    return content
}

export default AnswerForm